function downloadFromSource(url: string, fileName: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.setAttribute('href', url);
  downloadLink.setAttribute('download', fileName);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  downloadFromSource(url, fileName);
  window.URL.revokeObjectURL(url);
}

export function downloadTextInFile(text: string, fileName: string): void {
  const blob = new Blob([text], { type: 'text/plain' });
  downloadBlob(blob, `${fileName}.txt`);
}

export function downloadBase64(base64Data: string, fileName: string, mimeType: string): void {
  const url = `data:${mimeType};base64,${base64Data}`;
  downloadFromSource(url, fileName);
}
